import { render, staticRenderFns } from "./RegisterCompanyForm.vue?vue&type=template&id=296d9402"
import script from "./RegisterCompanyForm.vue?vue&type=script&lang=ts"
export * from "./RegisterCompanyForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports